<div class="topbar">
  <a routerLink="/" class="topbar-logo" style="width: 10vw;">
    <img src="assets/img/DNM/gris_sobre_fondo_blanco.png" style="border: 0 none; width: 12vw;"/>
  </a>
  <a routerLink="/" class="topbar-titulo" style="width: 15vw; margin-left: 3%">{{ nombreSistema }}</a>
  <div class="custom-breadcrumb p-component">
    <div id="nav-wrap" class="wrap-top nav-wrap">
      <div class="p-grid">
        <ul class="clearfix p-col-12">
          <a routerLink="/user/solicitudes/activas">
            <li>Solicitudes activas <i class="pi pi-angle-down" style="margin-top: 5px;"></i></li>
          </a>
          <a routerLink="/user/solicitudes/observadas">
            <li>Solicitudes observadas <i class="pi pi-angle-down"></i></li>
          </a>
          <a routerLink="/user/solicitudes/finalizadas">
            <li>Solicitudes finalizadas <i class="pi pi-angle-down"></i></li>
          </a>
          <a routerLink="/user/pagar-mandamiento">
            <li>Pagar mandamiento<i class="pi pi-angle-down"></i></li>
          </a>
          <a routerLink="/user/tramites/pendientes" *ngIf="tview">
            <li>
              Trámites pendientes
              <span>
                <i class="fa fa-fw fa-exclamation-triangle"></i> Ver
                <strong> {{ tpLength }} </strong> trámites pendientes</span
              >
            </li>
          </a>
        </ul>
      </div>
    </div>
  </div>
  <a href="#" id="user-display" (click)="app.onTopbarMenuButtonClick($event)" style="position: absolute; right: 1%;">
    <span class="username">{{ nombreCompletoUsuario }}</span>
    <img src="assets/img/DNM/avatar.png" style="border: 0px" />
    <span class="d-noti" *ngIf="tview">
      <i class="fa fa-exclamation"></i> {{ tpLength }}
    </span>
    <i class="fa fa-angle-down"></i>
  </a>
  <app-mensajes
    [code]="code"
    [titulo]="titulo"
    [detalle]="detalle"
    [sw]="sw"
  ></app-mensajes>
  <ul id="topbar-menu" class="fadeInDown" [ngClass]="{ 'topbar-menu-visible': app.topbarMenuActive }">
    <li role="menuitem">
      <a routerLink="/user/solicitudes/activas">
        <i class="fa fa-fw fa-hourglass-half"></i>
        <span>Solicitudes activas</span>
      </a>
    </li>
    <li role="menuitem">
      <a routerLink="/user/solicitudes/observadas">
        <i class="fa fa-fw fa-eye"></i>
        <span>Solicitudes observadas</span>
      </a>
    </li>
    <li role="menuitem">
      <a routerLink="/user/solicitudes/finalizadas">
        <i class="fa fa-fw fa-check"></i>
        <span>Solicitudes finalizadas</span>
      </a>
    </li>
    <li role="menuitem">
      <a routerLink="/user/pagar-mandamiento">
        <i class="pi pi-money-bill"></i>
        <span>Pagar mandamiento</span>
      </a>
    </li>
    <li role="menuitem" *ngIf="tview">
      <a routerLink="/user/tramites/pendientes">
        <i class="fa fa-fw fa-exclamation-triangle"></i>
        <span><strong>{{ tpLength }}</strong> Trámites pendientes</span>
      </a>
    </li>
    <li role="menuitem">
      <a (click)="cerrarSesion()">
        <i class="fa fa-fw fa-sign-out"></i>
        <span>Cerrar sesión</span>
      </a>
    </li>
  </ul>
  <app-spinner [visible]="visibleSpinner"></app-spinner>
</div>
<app-tramite-notificaciones
  *ngIf="tp"
  (data)="tramite($event)"
  [load]="load"
  [tmsg]="tmsg"
></app-tramite-notificaciones>

<p-dialog
  [header]="header"
  (onHide)="accept()"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <div style="text-align: center">
    <a [href]="url" target="_blank">
      <img
        [src]="img"
        alt="anuncio"
        [style.width.%]="100"
        [style.height.%]="100"
      />
    </a>
    <p>
      <span>{{ message }}</span>
    </p>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      icon="pi pi-check"
      (click)="accept()"
      label="Cerrar sesión"
    ></button>
  </p-footer>
</p-dialog>
